export default __webpack_public_path__ + "static/media/iconSuccess64.d5ef5bf5.svg";